import 'vite/modulepreload-polyfill';

import { loadPosthog } from './load-posthog';
import { loadReactApp } from './load-react-app';
import { loadSentry } from './load-sentry';
import { routes } from './routes/video-landing-page/routes';

// Ensure sentry is imported and initialized first
loadSentry();

loadPosthog();

loadReactApp(routes);
